var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "container mb-5 event-registration-wrapper" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-md-7 col-lg-8 event-right-container order-1 order-md-0",
          },
          [
            _vm.pageStatus === "loading"
              ? _c("el-skeleton", { attrs: { rows: 6, animated: "" } })
              : _vm.pageStatus === "already-registered"
              ? _c("already-registered", {
                  attrs: {
                    user: _vm.duplicateParticipant,
                    labels: _vm.eventConfig,
                  },
                })
              : _vm.pageStatus === "sold-out"
              ? _c("sold-out")
              : _vm.eventConfig &&
                _vm.eventConfig["oneclick-required"] &&
                !_vm.donationDetail
              ? _c("el-empty", {
                  attrs: {
                    "image-size": 200,
                    description:
                      "This event is by invitation only. Please contact events@nsw.liberal.org.au for further details.",
                  },
                })
              : ["not-found", "error", "invalid-ck-id"].includes(_vm.pageStatus)
              ? _c("el-empty", {
                  attrs: { "image-size": 200, description: "Event not found" },
                })
              : _vm.isEventLocked
              ? _c("el-empty", {
                  attrs: {
                    "image-size": 200,
                    description:
                      "This event is by invitation only. Please contact events@nsw.liberal.org.au for further details.",
                  },
                })
              : [
                  _vm.step === 1
                    ? _c("ticket-selection", {
                        attrs: {
                          labels: _vm.eventConfig,
                          donationConfig: _vm.donationConfig,
                          item: _vm.eventDetail,
                          tickets: _vm.tickets,
                        },
                        on: { "next-step": _vm.onNextStep },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 2
                    ? _c("participant", {
                        attrs: {
                          tickets: _vm.tickets,
                          eventDetail: _vm.eventDetail,
                          donationDetail: _vm.donationDetail,
                          eventConfig: _vm.eventConfig,
                          donationConfig: _vm.donationConfig,
                          participants: _vm.participants,
                        },
                        on: { "next-step": _vm.onNextStep },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 3
                    ? _c("billing-info", {
                        attrs: {
                          tickets: _vm.tickets,
                          eventConfig: _vm.eventConfig,
                          billingInfo: _vm.billingInfo,
                          donationDetail: _vm.donationDetail,
                          participants: _vm.participants,
                        },
                        on: { "next-step": _vm.onNextStep },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 4
                    ? _c("payment", {
                        attrs: {
                          tickets: _vm.tickets,
                          billingInfo: _vm.billingInfo,
                          eventConfig: _vm.eventConfig,
                          participants: _vm.participants,
                          userRoles: _vm.userRoles,
                        },
                        on: { "next-step": _vm.onNextStep },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 5
                    ? _c("thank-you", {
                        attrs: {
                          eventConfig: _vm.eventConfig,
                          receipt: _vm.receipt,
                          tickets: _vm.tickets,
                          participants: _vm.participants,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 6
                    ? _c("free-payment", {
                        attrs: {
                          tickets: _vm.tickets,
                          billingInfo: _vm.billingInfo,
                          eventConfig: _vm.eventConfig,
                          participants: _vm.participants,
                          userRoles: _vm.userRoles,
                        },
                        on: { "next-step": _vm.onNextStep },
                      })
                    : _vm._e(),
                ],
          ],
          2
        ),
        _vm._v(" "),
        !_vm.isEventLocked
          ? _c(
              "div",
              {
                staticClass:
                  "col-md-5 col-lg-4 event-left-container order-0 order-md-1",
              },
              [
                _vm.pageStatus === "loading"
                  ? _c("el-skeleton", { attrs: { rows: 10, animated: "" } })
                  : _c("event-detail-info", {
                      attrs: { status: _vm.pageStatus, item: _vm.eventDetail },
                    }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }